import { LinkedCredential } from '../../models';
import { ApiClient, CredentialDescriptor, Ctor, ReadClaims, UpdatePayload } from '../../types';
import { UdtClaims } from '../claims';
import { CredentialFlavor } from '../flavor';
import { Claims, CredentialBlob } from '../types';
import { VerifiableCredential } from './verifiable';

export class VerifiableCredentialWithClaims<T extends Claims> extends VerifiableCredential {
    private claims = new UdtClaims(this.client, this.claimsModel);

    constructor(
        client: ApiClient,
        protected flavor: CredentialFlavor,
        private claimsModel: Ctor<T>,
        descriptor: CredentialDescriptor,
        blob?: CredentialBlob,
    ) {
        super(client, descriptor, blob);
    }

    toLinkedCredential(): LinkedCredential<T> {
        return super.toLinkedCredential();
    }

    async getClaims(): Promise<ReadClaims<T>> {
        return this.claims.unmarshalValuesToCredential(await this.flavor.getClaims(await this.getBlob()));
    }

    async update(request: UpdatePayload): Promise<VerifiableCredentialWithClaims<T>> {
        let { etag, revision } = this.descriptor;

        if (request.labels) {
            const updatedCredential = await this.client.credentials.credentialUpdateLabels(this.descriptor.id, {
                ifMatch: etag,
                labels: request.labels,
            });

            etag = updatedCredential.etag;
            revision = updatedCredential.revision;
        }

        if (request.annotations) {
            const updatedCredential = await this.client.credentials.credentialUpdateAnnotations(this.descriptor.id, {
                ifMatch: etag,
                annotations: request.annotations,
            });

            etag = updatedCredential.etag;
            revision = updatedCredential.revision;
        }

        return new VerifiableCredentialWithClaims(
            this.client,
            this.flavor,
            this.claimsModel,
            {
                ...this.descriptor,
                etag,
                revision,
            },
            this.blob,
        );
    }
}
